import React from "react"
import { Box, Typography } from "@material-ui/core"

import { useGlobalStateStore } from "@/store/GlobalState"

import useStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/InstanceChip/styles"

type InstanceChipProps = {
	className?: string
}

const InstanceChip: React.FC<InstanceChipProps> = (props) => {
	const { className } = props

	const classes = useStyles()
	const globalStateStore = useGlobalStateStore()

	const instanceId = globalStateStore.instance.instance_id

	return (
		<Box className={`${classes.instanceChip} ${className ?? ""}`}>
			<Typography className={classes.instanceChipText}>
				Instância: {instanceId}
			</Typography>
		</Box>
	)
}

export default InstanceChip
